import classNames from "classnames";
import React, { forwardRef } from "react";
import { Button } from "react-bootstrap";
import IBuildrProps from '../../../utilities/IBuildrProps';
import { useBlogProps } from '../../../context/BlogPropContext';
import './BlogPrevNextButtons.scss';

const BlogPrevNextButtons = forwardRef((props: IBuildrProps, ref: any) => {
    const {
        cmsId,
        editorClassObj,
    } = props;

    const blogProps = useBlogProps();

    return (
        <div data-id={cmsId} ref={ref} className={classNames(editorClassObj, 'd-flex justify-content-end mt-4 prev-next-btn-container')}>
            <div className="text-center w-30 ml-2">
                {Boolean(blogProps) && Boolean(blogProps.previous) &&
                    <Button data-test-id="blog-previous-button" variant="outline-light" href={blogProps.previous.frontmatter.path}>Previous Article</Button>
                }
            </div>
            <div className="text-center w-30 ml-2">
                {Boolean(blogProps) && Boolean(blogProps.next) &&
                    <Button data-test-id="blog-next-button" variant="outline-light" href={blogProps.next.frontmatter.path}>Next Article</Button>
                }
            </div>
        </div>
    );
});

export default BlogPrevNextButtons;
